import { css } from 'styled-components';

export const CopyRegular = css`
  font-size: 2rem;
  line-height: 130%;
  letter-spacing: .5px;
`;